// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--ykBE5";
export var Message = "styles-module--Message--LoqLn";
export var Navigation = "styles-module--Navigation--OskL8";
export var Title = "styles-module--Title--NRJUN";